import React, { useState, useCallback, useEffect } from 'react';
import NodeInputHandler from './NodeInputHandler';
import AtomicTagInput from './AtomicTagInput';

const GenericNodeContent = ({ id, data, onChange, placeholder }) => {
  const [content, setContent] = useState(data.content || '');
  const [cursorPosition, setCursorPosition] = useState(0);

  useEffect(() => {
    setContent(data.content || '');
  }, [data.content]);

  const handleContentChange = useCallback((newContent) => {
    setContent(newContent);
    onChange(id, { content: newContent });
  }, [id, onChange]);

  const handleCursorChange = useCallback((position) => {
    setCursorPosition(position);
  }, []);

  const insertInput = useCallback((inputTag) => {
    const newContent = 
      content.slice(0, cursorPosition) + 
      inputTag + 
      content.slice(cursorPosition);
    
    handleContentChange(newContent);
    
    const newPosition = cursorPosition + inputTag.length;
    setCursorPosition(newPosition);
  }, [content, cursorPosition, handleContentChange]);

  return (
    <>
      <AtomicTagInput
        value={content}
        onChange={handleContentChange}
        onCursorChange={handleCursorChange}
        placeholder={placeholder || "Enter content"}
        className="nodrag"
      />
      <NodeInputHandler 
        nodeId={id} 
        onInsert={insertInput}
      />
    </>
  );
};

export default GenericNodeContent;